export default __webpack_public_path__ + "img/wikipedia_hover.a951cebc3a3dc296b36b58ad2924506f.svg";